import * as ApiWithToken from "../callApiWithToken";

const metricsRealTimeService = {
  GetMetricsList: async function (languageID: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `MetricRealTime/GetMetricRealTimeList?languageID=${languageID}`
    );
  },
  GetMetricsRealTime: async function (supervisorID: number, nameController: string) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
      `MetricRealTime/${nameController}?supervisorID=${supervisorID}`
    );
  },
  downloadMetric: async function (languageID: number, supervisorID: number, nameController: string) {
      return ApiWithToken.getApiBlob(
        process.env.REACT_APP_SURVEY_API +
        `DownloadMetricsRealTime/${nameController}?supervisorId=${supervisorID}&languageID=${languageID}`
      );
  }
}
export default metricsRealTimeService;